export default __webpack_public_path__ + "static/media/roboto-v20-latin-700.ba38a9cf.eot";